import React from 'react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { GrDocumentUser } from "react-icons/gr";
import { ReactTyped } from "react-typed";

const Home: React.FC = () => {
    return (
        <div className="home">
            <div className="container">
                <h1>
                    <strong>
                        <ReactTyped
                            strings={[
                                "Hi, I am Sophie ",
                                "Hi, I'm Sude"
                            ]}
                            typeSpeed={80}
                            backDelay={1100}
                            backSpeed={30}
                            loop
                        />
                        <span>👋🏻</span>
                    </strong>
                </h1>

                <h2 className="home-description">
                    Software Engineer at Wilson Tool International
                </h2>

                <p className="home-highlights">
                    McKinsey Forward • First Class Computer Science • BCSWomen Lovelace Finalist 2025
                </p>


                <div className="social-icons">
                    <a href="https://www.linkedin.com/in/sudefidan" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <FaLinkedin />
                    </a>
                    <a href="https://github.com/sudefidan" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <FaGithub />
                    </a>
                    <a href="https://drive.google.com/file/d/1sawviSFVFN9jw00nBor81-RHtPlmkXxR/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <GrDocumentUser />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Home;